import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { VipVipCommission } from "../../modules/vipVipCommission/components/VipVipCommission";

const VipVipCommissionContext = createContext();

const VipVipCommissionWrapper = () => {
  const value = {};

  return (
    <VipVipCommissionContext.Provider value={value}>
      <Routes>
        <Route path="" element={<VipVipCommission />} />
      </Routes>
    </VipVipCommissionContext.Provider>
  );
};

export { VipVipCommissionWrapper };
